import { useGetReceivedInvoiceSettingsService } from '@/context/services/ai_agents_setting/AiAgentsSetting.service';

export const useIsPaymentRequestSupportAgentEnabled = (enabled = true) => {
  const { isPaymentRequestSupportAgentEnabled } =
    useGetReceivedInvoiceSettingsService(enabled);
  return { enabled: isPaymentRequestSupportAgentEnabled };
};
